<template>
  <div class="columns">
    <div class="column">
      <b-field
        v-if="ractivity.category && ractivity.type"
        :label="translate('subtype')"
        :type="{ 'is-danger': errors.has('subtype') }"
        :message="errors.first('subtype')"
      >
        <b-select
          :disabled="disabled"
          expanded
          name="subtype"
          v-validate="'hasCalculationService|required'"
          :placeholder="translate('subtype')"
          v-model="ractivity.subtype"
        >
          <option
            :value="csubtype"
            v-for="(csubtype, index) in getSubTypes()"
            :key="index"
          >
            {{ getDescription(csubtype) }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field
        :label="translate('amount')"
        :type="{ 'is-danger': errors.has('amount') }"
        :message="errors.first('amount')"
      >
        <b-input
          :disabled="disabled"
          name="amount"
          :placeholder="translate('amount')"
          v-validate="'required|decimal'"
          v-model="ractivity.amount"
        />
        <p class="control">
          <span class="button is-static">
            {{ $t(unit) }}
          </span>
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
import { GENCIComputingFacilities } from '@/models/carbon/ResearchActivity.js'
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'Input',
  props: {
    ractivity: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  inject: ['$validator'],
  setup () {
    const ghgiStore = useGHGIStore()
    return { ghgiStore }
  },
  computed: {
    year: function () {
      return parseInt(this.ghgiStore.item.year)
    },
    unit: function () {
      if (this.ractivity.subtype) {
        return GENCIComputingFacilities.getUnit(
          null,
          null,
          this.ractivity.subtype
        )
      } else {
        return '-'
      }
    }
  },
  methods: {
    translate: function (key) {
      return GENCIComputingFacilities.translate(
        this.ractivity,
        key,
        this.$i18n.locale
      )
    },
    getSubTypes: function () {
      return GENCIComputingFacilities.getSubTypes(null, null, this.year)
    },
    getDescription: function (subtype) {
      return GENCIComputingFacilities.getDescription(
        this.ractivity.category,
        this.ractivity.type,
        subtype,
        this.$i18n.locale
      )
    }
  },
  created () {
    let self = this
    this.$validator.extend('hasCalculationService', {
      getMessage: (field) =>
        self.$t(
          'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesInput.error-1'
        ),
      validate: (value, args) => {
        return self.getSubTypes().length > 0
      }
    })
  },
  mounted () {
    if (this.getSubTypes().length === 0) {
      this.$validator.validateAll()
    }
  }
}
</script>
